import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory, useLocation, useParams } from 'react-router'
import * as _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'
import {
  getAllButtonOptions,
  getAllUserGroups,
} from '@/store/questions/actions'
import {
  deleteQuizQuestionBankById,
  generateQuestionBank,
  getAllQuestionBankNoPaging,
  getQuizFeatures,
  getQuizQuestionBankById,
  updateQuestionFromQuestionBank,
  updateQuiz,
} from '@/store/quizzes/actions'

import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { Container as DragContainer, Draggable } from 'react-smooth-dnd'
import ConfirmationModal from '@/components/UI/ConfirmationModal/ConfirmationModal'
import QuizQuestionEditor from '../QuizQuestionEditor/QuizQuestionEditor'
import '../styles.scss'
import {
  EDIT_QUESTIONS_BANK,
  GET_QUIZ_BYID,
  IMPORTQUESTIONBANK_PREVIEWS_QUESTIONS,
  EXERCISES,
} from '@/config'
import {
  bulkAssignModules,
  getAllDocumentsNewFlow,
} from '@/store/knowledge/actions'
import MoveSelectedModal from '@/components/UI/KnowledgeDatatableComponent/MoveSelectedModal'
import { getQuizByQuizId } from '@/store/dashboard/actions'
import ChildPageHeader from '@/components/UI/ChildPageHeader'
import { Button } from '@mui/material'
import { useGlobalContext } from '@/context/GlobalContext'

function CreateEditQuestionBank(props: any) {
  const { t } = useTranslation()
  const useLocatio = useLocation()
  const emptyQuestion: any = {
    is_saved: false,
    type: 'radio',
    text: '',
    score: 1,
    options: [
      {
        text: '',
        is_correct: false,
      },
      {
        text: '',
        is_correct: false,
      },
    ],
  }

  const params: any = useParams()
  const history = useHistory()
  const dispatch = useDispatch()
  const [transformedQuestions, setTransformedQuestions] = useState<any>({})
  const [savedQuestions, setSavedQuestions] = useState([])
  const [savedQuestionsBank, setSavedQuestionsBank] = useState([])
  const [essayConfig, setEssayConfig] = useState(null)
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false)
  const [toBeDeleted, setToBeDeleted] = useState(null)
  const [addNew, setAddNew] = useState(false)
  const [quizQuestionDropdownData, setQuizQuestionDropdownData] = useState([])
  const [selectedNodes, setSelectedNodes] = useState([])
  const [isMultiAct, setIsMultiAct] = useState(false)
  const [enableLearning, setEnableLearning] = useState(false)
  const [updatingQuizQuestionsFromParent, SetUpdatingQuizQuestionsFromParent] =
    useState(false)
  const [redirect, setRedirect] = useState('')
  const [hasAnyError, setHasAnyError] = useState([])
  const [componentHasError, setComponentHasError] = useState([])
  const [internalLoading, setInternalLoading] = useState(false)
  const [openModal, SetOpenModal] = useState(false)
  const [quizSubmitted, setQuizSubmitted] = useState(false)

  const [selectedMove, setSelectedMove] = useState(null)
  const [showMoveSelectModal, setShowMoveSelectModal] = useState(false)
  const [allDocuments, setAllDocuments] = useState([])
  const ref = useRef([])
  const backupRef = useRef([])
  const isMultiEdit =
    useLocatio.pathname === EDIT_QUESTIONS_BANK ||
    props.location.state?.createFromTestFile
  const isImportForQuiz = !!props.location.state?.quizId
  const { exportedQuestions, setExportQuestions } = useGlobalContext()

  const getQuestions = async () => {
    const res: any = await dispatch(
      getAllQuestionBankNoPaging({
        ids: exportedQuestions?.rows?.map((row: any) => row.rowId),
        sort_field: 'created_at',
        sort_order: 'asc',
      }),
    )
    backupRef.current = res
    transformAllQuestions(res)
    generateQuestionIdLabelMap(res)
    transformQuizDropdownData(res)
    setSavedQuestions(res)
  }

  useEffect(() => {
    if (params.questionId && !isMultiEdit) {
      getQuestionOfQuestioBank(params.questionId)
    } else if (exportedQuestions?.rows?.length) {
      //multiple questions edit
      getQuestions()
    }
    dispatch(getAllButtonOptions(true))
    dispatch(getAllUserGroups())
    getLearningFeature()
    getAllDocumentsHandler()
    if (
      typeof props.location.state !== 'undefined' &&
      props.location.state.selectedFileType &&
      props.location.state.quizArray &&
      props.location.state.quizArray.questions
    ) {
      backupRef.current = props.location.state.quizArray.questions
      transformAllQuestions(props.location.state.quizArray.questions)
      generateQuestionIdLabelMap(props.location.state.quizArray.questions)
      transformQuizDropdownData(props.location.state.quizArray.questions)
      setSavedQuestions(props.location.state.quizArray.questions)
      if (!props.location.state?.createFromTestFile) {
        SetOpenModal(true)
      }
    }

    return () => {
      setExportQuestions({
        rows: null,
        selectedYear: null,
      })
    }
  }, [])

  const getLearningFeature = async () => {
    try {
      const response: any = await dispatch(getQuizFeatures())
      setEssayConfig(
        response.features.find(
          (feature: any) =>
            feature?.name === 'essay_grader' && feature?.status === 'active',
        ),
      )
      if (response.features && response.features.length !== 0) {
        for (let i = 0; i < response.features.length; i++) {
          if (response.features[i].name === 'learning') {
            setEnableLearning(true)
            break
          }
        }
      } else {
        setEnableLearning(false)
      }
    } catch (error) {
      setEnableLearning(false)
    }
  }

  const getQuestionOfQuestioBank = async (quizId: string) => {
    try {
      const { quiz_question }: any = await dispatch(
        getQuizQuestionBankById(quizId),
      )
      let quizDetail: any = quiz_question
      quizDetail = {
        ...quizDetail,
        questions: [quizDetail],
      }

      if (quizDetail.questions && quizDetail.questions.length > 0) {
        backupRef.current = quizDetail.questions
        transformAllQuestions(quizDetail.questions)
        generateQuestionIdLabelMap(quizDetail.questions)
        transformQuizDropdownData(quizDetail.questions)
        setSavedQuestions(quizDetail.questions)
      } else {
        addNewQuestion()
      }
    } catch (error) {}
  }

  const getAllDocumentsHandler = async () => {
    try {
      const response: any = await dispatch(
        getAllDocumentsNewFlow(
          {
            page: 1,
            page_size: 100000,
          },
          false,
          false,
        ),
      )
      setAllDocuments(response.documents)
    } catch (error) {}
  }

  const transformAllQuestions = (questionList: any) => {
    let temp: any = {}

    // const subQuestions = questionList.filter((q: any) => !q.parent_id);
    // const mainQuestions = questionList.filter((q: any) => q.parent_id);
    // const questions = [...mainQuestions, ...subQuestions];
    questionList.forEach((question: any, index: number) => {
      question.subquestions = question?.sub_questions
        ? question?.sub_questions
        : []
      if (question.parent_id && temp[question.parent_id]) {
        const isExist = temp[question.parent_id].subquestions.find(
          (s: any) => s.id === question.id,
        )
        if (!isExist) {
          temp[question.parent_id] = {
            ...temp[question.parent_id],
            subquestions:
              'subquestions' in temp[question.parent_id]
                ? temp[question.parent_id].subquestions.concat([question])
                : [].concat([question]),
          }
        }
      } else {
        temp[question.id ? question.id : uuidv4()] = question
      }
    })
    setTransformedQuestions(temp)
  }

  const transformQuizDropdownData = (questions: any) => {
    let quizDropdown: any = []

    questions.forEach((item: any, index: number) => {
      if (item && item.text) {
        quizDropdown.push({
          value: item.id,
          label: <div dangerouslySetInnerHTML={{ __html: item.text }}></div>,
        })
      }
    })

    setQuizQuestionDropdownData(quizDropdown)
  }

  const generateQuestionIdLabelMap = (questions: any) => {
    let tempMap: any = {}
    questions.forEach((question: any, index: number) => {
      tempMap[question.id] = {
        label: <div dangerouslySetInnerHTML={{ __html: question.text }}></div>,
        options: question.options,
        type: question.type,
      }
    })
  }

  ///////////////////// QUIZ LEVEL ////////////////////
  const updateQuizQuestions = async (
    toUpdateQuestions: any,
    isGenerateKeywords: boolean = false,
    isLinkSections: boolean = false,
    qId: string = '',
  ) => {
    let questionId = params.questionId || (isMultiEdit && qId) || null
    try {
      if (!isLinkSections) {
        let subQues: any = []
        toUpdateQuestions.forEach((question: any) => {
          if (question?.type === 'group') {
            subQues = [...subQues, ...question?.data]
          }
          delete question?.data
        })
        toUpdateQuestions = _.uniqBy([...toUpdateQuestions, ...subQues], 'id')
        const response: any = await dispatch(
          questionId
            ? updateQuestionFromQuestionBank(
                questionId,
                {
                  questions: toUpdateQuestions,
                },
                !props.location.state?.createFromTestFile,
              )
            : !isMultiEdit &&
                generateQuestionBank({
                  questions: toUpdateQuestions,
                }),
        )
        if (
          props.location.state?.createFromTestFile &&
          useLocatio.pathname === IMPORTQUESTIONBANK_PREVIEWS_QUESTIONS
        ) {
          // setSavedQuestionsBank([...savedQuestions, response.quiz_question])

          setSavedQuestionsBank(preSavedQuestions => {
            if (
              !preSavedQuestions.find(q => q.id === response?.quiz_question.id)
            ) {
              return [...preSavedQuestions, response.quiz_question]
            }
          })

          // await saveQuestionsToQuiz([response.quiz_question])
        }
        if (!questionId && response) {
          const query = new URLSearchParams(useLocatio.search)
          const group: string = query.get('group')
          const nodes: string[] = response.quiz_questions.map((q: any) => q.id)
          group && (await dispatch(bulkAssignModules(group, nodes, 'question')))
        }

        if (props.location.state?.createFromTestFile) {
          if (redirect) {
            history.push(redirect)
            return
          }
          if (useLocatio.pathname === IMPORTQUESTIONBANK_PREVIEWS_QUESTIONS) {
            return
          }

          history.push(IMPORTQUESTIONBANK_PREVIEWS_QUESTIONS, {
            questionList: savedQuestions.map((q: any) => q.id),
            selectedFileType: 'customtemplates',
            createFromTestFile: true,
            quizId: props.location.state?.quizId,
            school: props.location.state?.school,
          })

          return
        }
      }

      if (questionId && !isMultiEdit) {
        getQuestionOfQuestioBank(questionId)
      } else if (isMultiEdit) {
        getQuestions()
      }

      !questionId && history.push(EXERCISES + '?tab=bank')
    } catch (error) {}
  }

  ///////////////////// QUIZ EDITOR ////////////////////
  const setErrorIfAny = async (temp: any, questionId: any) => {
    const questions: any[] = [...hasAnyError]
    questions.push(temp)
    ref.current.push(temp)
    setHasAnyError(questions)
    const hasInvalidOption = _.uniqBy(ref.current, 'id')
      .filter(function (el: any) {
        return el
      })
      .filter(function (el: any) {
        return el.invalid
      })

    if (
      ref.current.length === Object.keys(transformedQuestions).length &&
      hasInvalidOption.length === 0 &&
      !isMultiEdit
    ) {
      await updateQuizQuestions(
        _.uniqBy(ref.current, 'id'),
        false, // isGenerateKeywords
        false, // isLinkSections,
        questionId,
      )
    } else if (isMultiEdit && hasInvalidOption.length === 0) {
      await updateQuizQuestions(
        _.uniqBy(ref.current, 'id'),
        false, // isGenerateKeywords
        false, // isLinkSections,
        questionId,
      )
    }

    return
  }

  const updateQuizQuestionsFromParent = async () => {
    ref.current = []
    setInternalLoading(true)
    setQuizSubmitted(true)
    setHasAnyError([])
    setComponentHasError([])
    SetUpdatingQuizQuestionsFromParent(true)
    return
  }

  const onDelete = async () => {
    if (params.questionId) {
      try {
        await dispatch(deleteQuizQuestionBankById(params.questionId))
        setOpenDeleteConfirm(false)
        history.goBack()
      } catch (error) {
        setOpenDeleteConfirm(false)
      }
    } else {
      let tempQuestions = [...backupRef.current]
      tempQuestions.forEach((question, index) => {
        if (toBeDeleted === question.id) {
          tempQuestions.splice(index, 1)
        }
      })
      if (isMultiEdit) {
        if (isMultiAct) {
          selectedNodes.map(
            async (id: string) =>
              await dispatch(deleteQuizQuestionBankById(id)),
          )
          tempQuestions = tempQuestions.filter(
            q => !selectedNodes.includes(q.id),
          )
          setSelectedNodes([])
        } else {
          await dispatch(deleteQuizQuestionBankById(toBeDeleted))
          setSelectedNodes(selectedNodes.filter(id => id !== toBeDeleted))
        }
      }

      backupRef.current = tempQuestions
      transformAllQuestions(tempQuestions)

      let tempSavedQuestions = [...savedQuestions]
      tempSavedQuestions.forEach((question, index) => {
        if (toBeDeleted === question.id) {
          tempSavedQuestions.splice(index, 1)
        }
      })

      setSavedQuestions(tempSavedQuestions)
      generateQuestionIdLabelMap(tempSavedQuestions)
      transformQuizDropdownData(tempSavedQuestions)
      let toUpdateQuestions: any = []
      tempSavedQuestions.forEach(question => {
        if (question !== null) {
          toUpdateQuestions.push(question)
        }
      })
      setOpenDeleteConfirm(false)
    }
  }

  const directQuestionDelete = (questionId: any) => {
    setAddNew(false)
    let tempQuestions = [...backupRef.current]
    tempQuestions.forEach((question, index) => {
      if (questionId === question.id) {
        tempQuestions.splice(index, 1)
      }
    })
    backupRef.current = tempQuestions
    transformAllQuestions(tempQuestions)

    let tempSavedQuestions = [...savedQuestions]
    tempSavedQuestions.forEach((question, index) => {
      if (questionId === question.id) {
        tempSavedQuestions.splice(index, 1)
      }
    })
    setSavedQuestions(tempSavedQuestions)
    generateQuestionIdLabelMap(tempSavedQuestions)
    transformQuizDropdownData(tempSavedQuestions)

    let toUpdateQuestions: any[] = []
    tempSavedQuestions.forEach(question => {
      if (question !== null) {
        toUpdateQuestions.push(question)
      }
    })
    updateQuizQuestions(toUpdateQuestions)
  }

  const onQuestionSort = (data: any) => {
    backupRef.current = data
    transformAllQuestions(data)

    let tempSavedQuestions = [...data]
    setSavedQuestions(tempSavedQuestions)
    generateQuestionIdLabelMap(tempSavedQuestions)
    transformQuizDropdownData(tempSavedQuestions)

    let toUpdateQuestions: any[] = []
    tempSavedQuestions.forEach(question => {
      if (question !== null) {
        toUpdateQuestions.push(question)
      }
    })
    updateQuizQuestions(toUpdateQuestions)
  }

  const onGroupQuestionSave = async (data: any, queIds: any) => {
    setAddNew(false)
    let tempQuestions = [...backupRef.current]
    data.forEach((questionToSave: any, mainIndex: any) => {
      tempQuestions.forEach((question, subIndex) => {
        if (queIds[mainIndex] === question.id) {
          tempQuestions[subIndex] = questionToSave
        }
      })
    })

    backupRef.current = tempQuestions
    transformAllQuestions(tempQuestions)

    let tempSavedQuestions = [...savedQuestions]
    data.forEach((questionToSave: any, mainIndex: any) => {
      tempSavedQuestions.forEach((question, subIndex) => {
        if (queIds[mainIndex] === question.id) {
          tempSavedQuestions[subIndex] = questionToSave
        }
      })
    })
    setSavedQuestions(tempSavedQuestions)
    generateQuestionIdLabelMap(tempSavedQuestions)
    transformQuizDropdownData(tempSavedQuestions)

    let toUpdateQuestions: any[] = []
    tempSavedQuestions.forEach(question => {
      if (question !== null) {
        toUpdateQuestions.push(question)
      }
    })
    updateQuizQuestions(toUpdateQuestions)
  }

  const onSave = async (
    updatedQuestion: any,
    questionId: any,
    isGenerateKeywords: boolean = false,
    isLinkSections: boolean = false,
  ) => {
    setAddNew(false)

    let tempQuestions = [...backupRef.current]
    tempQuestions.forEach((question, index) => {
      if (questionId === question.id) {
        tempQuestions[index] = updatedQuestion
      }
    })
    backupRef.current = tempQuestions
    transformAllQuestions(tempQuestions)

    let tempSavedQuestions = [...savedQuestions]
    tempSavedQuestions.forEach((question, index) => {
      if (question) {
        if (questionId === question.id) {
          tempSavedQuestions[index] = updatedQuestion
        }
      }
    })
    setSavedQuestions(tempSavedQuestions)
    generateQuestionIdLabelMap(tempSavedQuestions)
    transformQuizDropdownData(tempSavedQuestions)

    let toUpdateQuestions: any[] = []
    tempSavedQuestions.forEach(question => {
      if (question !== null) {
        toUpdateQuestions.push(question)
      }
    })
    updateQuizQuestions(
      toUpdateQuestions,
      isGenerateKeywords,
      isLinkSections,
      questionId,
    )
  }

  useEffect(() => {
    return () => {
      // cleanup
    }
  }, [ref])

  const confirmDelete = (questionId: any) => {
    setToBeDeleted(questionId)
    setOpenDeleteConfirm(true)
  }

  const addNewQuestion = (type: any = null, parentId: any = null) => {
    let emptyOptions: any = [...emptyQuestion.options]
    emptyOptions.forEach((option: any, index: any) => {
      emptyOptions[index] = {
        ...option,
        id: uuidv4(),
      }
    })

    emptyQuestion.options = emptyOptions

    let tempQuestions = [...backupRef.current]
    let newQ: any = { ...emptyQuestion }
    newQ.id = uuidv4()
    newQ.isNew = true

    if (type === 'sub') {
      newQ.parent_id = parentId
    }
    tempQuestions.push(newQ)
    transformAllQuestions(tempQuestions)
    backupRef.current = tempQuestions

    let tempSavedQuestions = [...savedQuestions]
    tempSavedQuestions.push(newQ)
    setSavedQuestions(tempSavedQuestions)

    if (!type) {
      setAddNew(true)
    }
  }

  const transformQuestion = (question: any) => {
    let temp = {
      ...question,
      score: !question.score || question.score === null ? 1 : question.score,
    }
    if (question.options) {
      let opt: any[] = []
      question.options.forEach((option: any, index: any) => {
        opt[index] = {
          ...option,
          id: option.id || uuidv4(),
          text: option.text,
          is_correct: option.is_correct,
        }
      })
      temp.options = opt
    }
    return temp
  }

  const reorder = (list: any, startIndex: any, endIndex: any) => {
    const result = Array.from(list)
    const [removed] = result.splice(startIndex, 1)
    result.splice(endIndex, 0, removed)

    return result
  }

  const onDrop = (dropResult: any) => {
    const { removedIndex, addedIndex, payload, element } = dropResult
    if (addedIndex === undefined) {
      return
    }
    const temp = reorder(backupRef.current, removedIndex, addedIndex)
    onQuestionSort(temp)
  }

  const getChildPayload = (index: any) => {
    return backupRef.current[index]
  }
  const addToSelectedRows = (event: any, id: string) => {
    let data: any[] = [...selectedNodes]
    if (event.target.checked) {
      const isPresent = data.indexOf(id)
      if (isPresent < 0) {
        data.push(id)
      }
    } else {
      const oldData = [...selectedNodes]
      const index = oldData.indexOf(id)
      oldData.splice(index, 1)
      data = [...oldData]
    }
    setSelectedNodes([..._.uniq(data)])
  }

  const renderItem = (question: any, index: any, questions: any) => {
    return (
      <div className="sortable-item ">
        <QuizQuestionEditor
          essayConfig={essayConfig ? essayConfig?.params : null}
          isNew={question.isNew ? question.isNew : false}
          key={question.id || 'que_' + index}
          questionNumber={index}
          questionId={question.id || index}
          data={transformQuestion(question)}
          enableLearning={enableLearning}
          activateEditAsProps={
            typeof props.location.state !== 'undefined' &&
            props.location.state.selectedFileType &&
            (props.location.state?.tagReview ||
              !props.location.state?.createFromTestFile)
          }
          updatingQuizQuestionsFromParent={updatingQuizQuestionsFromParent}
          SetUpdatingQuizQuestionsFromParent={
            SetUpdatingQuizQuestionsFromParent
          }
          hasAnyError={hasAnyError}
          onSetErrorIfAny={setErrorIfAny}
          parentRef={ref}
          hasLastIndex={index + 1 === Object.keys(transformedQuestions).length}
          defaultEditable={!props.location.state?.createFromTestFile}
          topicDropdownData={[]}
          showKeyword={false}
          hideActions={
            props.location.state?.tagReview ||
            props.location.state?.createFromTestFile
          }
          onQuestionSave={onSave}
          updateQuizQuestionsFromParent={updateQuizQuestionsFromParent}
          onQuestionDelete={confirmDelete}
          addNew={addNew}
          directQuestionDelete={directQuestionDelete}
          quizQuestionDropdownData={quizQuestionDropdownData}
          allQuestions={backupRef.current}
          addNewQuestion={addNewQuestion}
          onGroupQuestionSave={onGroupQuestionSave}
          isQuestionBank
          questionBankId={params.questionId}
          isQuestionBankEditable={params.questionId || isMultiEdit || false}
          questionBank={question}
          allDocuments={[...allDocuments]}
          enableDrag={!isMultiEdit}
          showCheckbox={isMultiEdit && !props.location.state?.tagReview}
          selectedNodes={selectedNodes}
          addToSelectedRows={addToSelectedRows}
          isQuestionBankMultiEdit={isMultiEdit}
          groupTagLabelClick={(q: any) => {
            setShowMoveSelectModal(true)
            setSelectedMove(q?.id)
          }}
        />
      </div>
    )
  }

  const getBuildQuizHtml = () => (
    <>
      {componentHasError.length > 0 &&
        typeof props.location.state !== 'undefined' &&
        props.location.state.selectedFileType &&
        quizSubmitted && (
          <div className="card-error">
            {t(
              'The questions were imported successfully but there are some errors in few of the questions. Please resolve the errors in the highlighted questions before saving',
            )}
          </div>
        )}

      <ConfirmationModal
        message={t(
          'Questions imported successfully. You can now edit the questions/answers. Click on "Save Quiz" to save this quiz?',
        )}
        size={'md'}
        show={openModal}
        onHide={() => SetOpenModal(false)}
        confirmHandler={() => {
          SetOpenModal(false)
        }}
      />

      <div>
        {/* {backupRef.current.length === 0 && ( */}
        {savedQuestions.length === 0 && (
          <div className="page-banner text-center">
            <p>
              {t(
                "You don't have any question yet. Click the button below to add a question.",
              )}
            </p>
            <button
              onClick={addNewQuestion}
              className="btn btn-outline-primary"
            >
              + {t('Add Another Question')}
            </button>
          </div>
        )}

        {Object.keys(transformedQuestions).length > 0 && (
          <>
            <DragContainer
              onDrop={onDrop}
              getChildPayload={getChildPayload}
              dragHandleSelector=".drag-handle"
            >
              {Object.keys(transformedQuestions).map(
                (questionId: any, index: any) => {
                  return (
                    <Draggable
                      key={questionId}
                      // className={params.questionId ? "p-0" : ""}
                    >
                      {renderItem(
                        transformedQuestions[questionId],
                        index,
                        Object.values(transformedQuestions),
                      )}
                    </Draggable>
                  )
                },
              )}
            </DragContainer>
            {!params.questionId && !isMultiEdit && (
              <div className="add-btn-container text-center">
                <button
                  onClick={addNewQuestion}
                  className="btn btn-outline-primary"
                >
                  + {t('Create question from scratch')}
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </>
  )

  const onSelectAllRows = (event: any) => {
    if (event.target.checked) {
      if (Object.keys(transformedQuestions).length > 0) {
        const quizzes: any = Object.keys(transformedQuestions)
        setSelectedNodes([..._.uniq(quizzes)])
      }
    } else {
      setSelectedNodes([])
    }
  }

  const confirmCategoryUpdateHandler = async (selectedOption: any) => {
    try {
      setShowMoveSelectModal(false)
      let moveQuestions = []
      if (isMultiAct) {
        moveQuestions = selectedNodes.map(
          (id: any) => transformedQuestions[id]?.id,
        )
      } else {
        moveQuestions = [selectedMove]
      }
      await dispatch(
        bulkAssignModules(
          selectedOption,
          // moveQuestions.map((qId: any) => transformedQuestions?.[qId]._id),
          moveQuestions,
          'question',
        ),
      )
      getQuestions()
      if (isMultiAct) {
        setSelectedNodes([])
        setIsMultiAct(false)
      }
      // getAllQuestionBankHandler();
    } catch (error: any) {
      if (isMultiAct) {
        setSelectedNodes([])
        setIsMultiAct(false)
      }
    }
  }
  const maxQuestions: number = Object.keys(transformedQuestions).length

  const getTitle = () => {
    if (props.location.state?.createFromTestFile) {
      return props.location.state?.tagReview
        ? t('Generate Keywords')
        : t('Review Question(s)')
    }

    if (params.questionId || isMultiEdit) {
      return t('Edit Question(s)')
    }

    return t('Create Questions')
  }

  const getSubTitle = () => {
    if (props.location.state?.createFromTestFile) {
      return props.location.state?.tagReview
        ? t(
            'Select and assign questions to be saved in specified knowledge group',
          )
        : t(
            'Select and assign questions to be saved in specified knowledge group',
          )
    }
    if (params.questionId) {
      return t('Manage and edit quiz questions')
    }
    if (isMultiEdit) {
      return t('Manage your question-answer pairs, keywords, and save changes.')
    }
    return t('Convert the knowledge into quiz questions')
  }

  const saveQuestionsToQuiz = async (quizQuesstions: any[]) => {
    try {
      const quizId = props.location.state?.quizId
      const { quizDetail }: any = await dispatch(getQuizByQuizId(quizId))
      const quizSavedQuestions = quizQuesstions.map((q: any) => ({
        ...q,
        quiz_question_id: quizId,
      }))
      const response: any = await dispatch(
        updateQuiz(
          quizId,
          {
            questions: [...quizSavedQuestions, ...quizDetail.questions],
          },
          true,
        ),
      )

      history.push(GET_QUIZ_BYID.replace(':quizId', quizId))
    } catch (error) {
      console.log('[ error ]', error)
    }
  }

  const saveGotoPreviews = async () => {
    await updateQuizQuestionsFromParent()
  }

  const saveAndGotoQuestionsbanks = async () => {
    setRedirect(EXERCISES + '?tab=bank')
    await updateQuizQuestionsFromParent()
  }

  useEffect(() => {
    const items: any = Object.keys(transformedQuestions)
    if (
      savedQuestionsBank &&
      items &&
      savedQuestionsBank?.length > 0 &&
      items?.length > 0 &&
      items.length === savedQuestionsBank.length
    ) {
      saveQuestionsToQuiz(savedQuestionsBank)
      setSavedQuestionsBank([])
    }
  }, [savedQuestionsBank, transformedQuestions])

  return (
    <section
      className={classNames({
        'page-mid-wraper': true,
        'h-without-foter': props.location.state?.createFromTestFile,
      })}
    >
      <MoveSelectedModal
        show={showMoveSelectModal}
        onHide={() => {
          setShowMoveSelectModal(false)
        }}
        confirmCategoryUpdate={confirmCategoryUpdateHandler}
      />
      {!props.location.state?.createFromTestFile && (
        <ChildPageHeader
          title={getTitle()}
          subTitle={getSubTitle()}
          slot={{
            action: !params.questionId && !isMultiEdit && (
              <Button
                onClick={updateQuizQuestionsFromParent}
                variant="contained"
                sx={{ ml: 'auto' }}
              >
                {t('Add to Question Bank')}
              </Button>
            ),
          }}
        />
      )}

      <div>
        <div className="pl-lg-3">
          <div className="d-flex flex-wrap justify-content-between mb-24 align-items-center">
            {props.location.state?.createFromTestFile &&
              !props.location.state?.tagReview &&
              !isImportForQuiz && (
                <div>
                  <button
                    className="btn btn-primary font-600 py-1"
                    onClick={() => saveAndGotoQuestionsbanks()}
                  >
                    {t('View Question Bank')}
                  </button>
                  <button
                    className="btn btn-outline-primary font-600 py-1 mx-2"
                    disabled={selectedNodes && selectedNodes.length < 1}
                    onClick={() => {
                      setShowMoveSelectModal(true)
                      setIsMultiAct(true)
                    }}
                  >
                    {t('Move Selected')}
                  </button>
                </div>
              )}

            {props.location.state?.createFromTestFile &&
              props.location.state?.tagReview && (
                <button
                  className="btn btn-primary font-600 py-1"
                  onClick={() => {
                    saveGotoPreviews()
                  }}
                >
                  {t('Save and Review Question(s)')}
                </button>
              )}

            {props.location.state?.createFromTestFile &&
              !props.location.state?.tagReview &&
              isImportForQuiz && (
                <div>
                  <button
                    className="btn btn-outline-primary font-600 py-1 mx-2"
                    disabled={selectedNodes && selectedNodes.length < 1}
                    onClick={() => {
                      setShowMoveSelectModal(true)
                      setIsMultiAct(true)
                    }}
                  >
                    {t('Move Selected')}
                  </button>
                  <button
                    className="btn btn-primary font-600 py-1"
                    onClick={() => {
                      setSavedQuestionsBank([])
                      updateQuizQuestionsFromParent()
                    }}
                  >
                    {t('Add All Questions to Quiz')}
                  </button>
                </div>
              )}
          </div>

          {isMultiEdit && !props.location.state?.tagReview && (
            <div
              className="d-flex flex-wrap align-items-center my-3"
              style={{ minHeight: '40px' }}
            >
              {Object.keys(transformedQuestions).length !== 0 && (
                <div className="custom-checkbox mr-3">
                  <input
                    type="checkbox"
                    className="mr-2"
                    id="select-all"
                    checked={
                      selectedNodes.length === maxQuestions &&
                      maxQuestions !== 0
                    }
                    onChange={onSelectAllRows}
                  />
                  <label htmlFor="select-all" className="mb-0">
                    {t('Select all')}
                  </label>
                </div>
              )}
              {selectedNodes && selectedNodes.length > 0 && (
                <>
                  {!props.location.state?.createFromTestFile && (
                    <button
                      className="btn btn-suggest py-0 font-sm"
                      onClick={() => {
                        setShowMoveSelectModal(true)
                        setIsMultiAct(true)
                      }}
                    >
                      {t('Move Selected')}
                    </button>
                  )}
                  <button
                    className="btn btn-suggest py-0 font-sm"
                    onClick={() => {
                      setIsMultiAct(true)
                    }}
                  >
                    {t('Assign Keywords')}
                  </button>
                  <button
                    className="btn btn-outline-danger border-0 py-0 font-600 font-sm"
                    onClick={() => {
                      setOpenDeleteConfirm(true)
                      setIsMultiAct(true)
                    }}
                  >
                    {t('Delete Selected')}
                  </button>
                </>
              )}
            </div>
          )}
          {typeof props.location.state !== 'undefined' &&
            props.location.state.selectedFileType && (
              <div className="extract-quiz-wrapper">
                <div className="extract-quiz-questions">
                  {getBuildQuizHtml()}
                </div>
              </div>
            )}

          {!(
            typeof props.location.state !== 'undefined' &&
            props.location.state.selectedFileType
          ) && getBuildQuizHtml()}
          <div className="half-clearfix" />
          <div className="action-btn-container">
            {typeof props.location.state !== 'undefined' &&
              props.location.state.selectedFileType &&
              !props.location.state?.createFromTestFile && (
                <button
                  onClick={updateQuizQuestionsFromParent}
                  disabled={internalLoading}
                  className="btn btn-primary font-600"
                >
                  {t('Save Quiz')}
                </button>
              )}
          </div>
        </div>
        <ConfirmationModal
          message={t('Are you sure you want to delete this question?')}
          size={'md'}
          show={openDeleteConfirm}
          onHide={() => setOpenDeleteConfirm(false)}
          confirmHandler={onDelete}
        />
      </div>
    </section>
  )
}

export default CreateEditQuestionBank
